/* eslint-disable max-len */
import styled from 'styled-components'
import { number, string } from 'prop-types'
import { prop } from 'styled-tools'
import colorsOptions from '../../../components/stories/fundamentals/colors-styles/constants'

const Svg = styled.svg`
  cursor: pointer;
  width: ${prop('size', 16)}px;
  height: ${prop('size', 16)}px;
  & g rect {
    fill: none;
  }
  .a {
    transform: translate(1.333 1.333);
  }
  .b {
    transform: translate(-4 -4);
    fill: ${prop('color', colorsOptions.greys.white)};
  }
  &:hover {
    cursor: pointer;
    .b {
      fill: ${prop('hoverColor', colorsOptions.greys['grey-05'])};
    }
  }
`

function CopyIcon({ color, hoverColor, size, ...props }) {
  return (
    <Svg
      viewBox="0 0 17 17"
      size={size}
      color={color}
      hoverColor={hoverColor}
      {...props}
    >
      <g id="invisible_box">
        <rect id="Rechteck_9779" width="16" height="16" fill="none" />
      </g>
      <g className="a">
        <path
          className="b"
          d="M14.667,6.667v-2A.667.667,0,0,0,14,4H4.667A.667.667,0,0,0,4,4.667V14a.667.667,0,0,0,.667.667h2v2a.667.667,0,0,0,.667.667h9.333a.667.667,0,0,0,.667-.667V7.333a.667.667,0,0,0-.667-.667ZM5.333,13.333v-8h8v8ZM16,16H8V14.667h6A.667.667,0,0,0,14.667,14V8H16Z"
        />
      </g>
    </Svg>
  )
}

CopyIcon.propTypes = {
  color: string,
  hoverColor: string,
  size: number,
}

export default CopyIcon
